import { AbstractModel, DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { DeactivationReason } from './deactivation-reason';

@inheritSerialization(AbstractModel)
export class DriverSuspension extends AbstractModel {
  @autoserialize
  driverId: number;

  @autoserializeAs(DeactivationReason)
  deactivationReason: DeactivationReason;

  @autoserializeAs(Date)
  effectiveAt: Date;

  @autoserialize
  durationHours: number;

  @autoserialize
  cancelReservations: boolean;

  @autoserialize
  active: boolean;

  @autoserialize
  effective: boolean;

  @autoserialize
  createdByUserId: number;

  @autoserialize
  cancelledByUserId: number;
}
